export default __webpack_public_path__ + "static/media/GL.9122e2bc.svg";